import { shaka } from '@cbsinteractive/avia-js-shaka';
import { EmbedType } from 'tag/ts/tag/model/type/embed/EmbedType';
import { AviaPlugin } from 'tag/ts/tag/player/adapters/avia/plugins/AviaPlugin';
export class ShakaPlugin extends AviaPlugin {
    package = shaka;
    namespaceKey = 'plugin_shaka';
    constructor(argument) {
        super({
            ...argument,
            name: 'ShakaPlugin'
        });
    }
    getFactoryParams() {
        const shakaURL = this.utils.String.cleanUp(this.utils.URL.addCacheToken(this.tag?.model?.config?.tag?.Imports?.params?.low_level?.shaka?.url?.regular, this.runtimeVO?.debug?.cacheBust));
        let shakaPluginConfig = {};
        switch (this?.params?.SYSTEM?.embedType) {
            case EmbedType.DESKTOP:
            case EmbedType.MOBILE_WEB:
                shakaPluginConfig = {
                    streaming: {
                        retryParameters: {
                            maxAttempts: 1,
                            timeout: 24000
                        }
                    },
                    preferredVideoHdrLevel: ''
                };
                break;
            case EmbedType.HTML5:
                shakaPluginConfig = {
                    preferredVideoHdrLevel: ''
                };
                break;
        }
        return {
            ...super.getFactoryParams(),
            dependencies: {
                shaka: shakaURL
            },
            config: shakaPluginConfig
        };
    }
}
